import api from '../utils/api';

const libraryService = {
  async getCategories() {
    return api.get('/api/library/categories');
  },

  async createCategory(data) {
    return api.post('/api/library/categories', data);
  },

  async updateCategory(id, data) {
    return api.put(`/api/library/categories/${id}`, data);
  },

  async deleteCategory(id) {
    return api.delete(`/api/library/categories/${id}`);
  },

  async getTags() {
    return api.get('/api/library/tags');
  },

  async deleteTag(id) {
    return api.delete(`/api/library/tags/${id}`);
  },

  async getItems(params = {}) {
    return api.get('/api/library/items', { params });
  },

  async getItem(id) {
    return api.get(`/api/library/items/${id}`);
  },

  async createItem(formData) {
    return api.post('/api/library/items', formData);
  },

  async updateItem(id, formData) {
    return api.put(`/api/library/items/${id}`, formData);
  },

  async deleteItem(id) {
    return api.delete(`/api/library/items/${id}`);
  },

  async trackView(id) {
    return api.post(`/api/library/items/${id}/view`);
  },

  async trackDownload(id) {
    return api.post(`/api/library/items/${id}/download`);
  },

  async getFavorites(params = {}) {
    return api.get('/api/library/favorites', { params });
  },

  async favoriteItem(id) {
    return api.post(`/api/library/items/${id}/favorite`);
  },

  async unfavoriteItem(id) {
    return api.delete(`/api/library/items/${id}/favorite`);
  },

  async rateItem(id, data) {
    return api.post(`/api/library/items/${id}/rating`, data);
  },

  async getItemRatings(id, params = {}) {
    return api.get(`/api/library/items/${id}/ratings`, { params });
  },

  // --- Physical circulation ---

  async getCopies(params = {}) {
    return api.get('/api/library/copies', { params });
  },

  async createCopy(data) {
    return api.post('/api/library/copies', data);
  },

  async updateCopy(id, data) {
    return api.put(`/api/library/copies/${id}`, data);
  },

  async deleteCopy(id) {
    return api.delete(`/api/library/copies/${id}`);
  },

  async lookupBorrowers(query) {
    return api.get('/api/library/borrowers/lookup', { params: { query } });
  },

  async getLoans(params = {}) {
    return api.get('/api/library/loans', { params });
  },

  async getMyLoans() {
    return api.get('/api/library/loans/mine');
  },

  async issueLoan(data) {
    return api.post('/api/library/loans', data);
  },

  async scanLookup(barcode) {
    return api.get(`/api/library/scan/${encodeURIComponent(barcode)}`);
  },

  async returnLoan(id) {
    return api.post(`/api/library/loans/${id}/return`);
  },

  async renewLoan(id) {
    return api.post(`/api/library/loans/${id}/renew`);
  },

  async reportLoanLost(id, replacementCost) {
    return api.post(`/api/library/loans/${id}/report-lost`, { replacement_cost: replacementCost });
  },

  async getFines(params = {}) {
    return api.get('/api/library/fines', { params });
  },

  async payFine(id, paymentMethod = 'cash') {
    return api.post(`/api/library/fines/${id}/pay`, { payment_method: paymentMethod });
  },

  async waiveFine(id, reason) {
    return api.post(`/api/library/fines/${id}/waive`, { reason });
  },

  async getFinesSummary() {
    return api.get('/api/library/fines/summary');
  },

  async getFineSettings() {
    return api.get('/api/library/fine-settings');
  },

  async updateFineSettings(data) {
    return api.put('/api/library/fine-settings', data);
  },

  async getReservations(params = {}) {
    return api.get('/api/library/reservations', { params });
  },

  async createReservation(data) {
    return api.post('/api/library/reservations', data);
  },

  async cancelReservation(id) {
    return api.delete(`/api/library/reservations/${id}`);
  },

  // --- Patron status & borrowing limits ---

  async getPatronCard(userId) {
    return api.get(`/api/library/patrons/${userId}`);
  },

  async setPatronStatus(userId, data) {
    return api.put(`/api/library/patrons/${userId}/status`, data);
  },

  // --- Weeding ---

  async retireCopy(id, reason) {
    return api.post(`/api/library/copies/${id}/retire`, { reason });
  },

  // --- Circulation reports ---

  async getCirculationReport(params = {}) {
    return api.get('/api/library/reports/circulation', { params });
  },

  // --- Digital licensing / concurrent access ---

  async checkoutAccess(itemId) {
    return api.post(`/api/library/items/${itemId}/checkout-access`);
  },

  async releaseAccess(itemId) {
    return api.post(`/api/library/items/${itemId}/release-access`);
  },

  // --- Acquisitions ---

  async getAcquisitions(params = {}) {
    return api.get('/api/library/acquisitions', { params });
  },

  async createAcquisition(data) {
    return api.post('/api/library/acquisitions', data);
  },

  async linkAcquisitionPurchaseOrder(id, purchaseOrderId) {
    return api.post(`/api/library/acquisitions/${id}/link-purchase-order`, { purchase_order_id: purchaseOrderId });
  },

  async receiveAcquisition(id, data) {
    return api.post(`/api/library/acquisitions/${id}/receive`, data);
  },

  async cancelAcquisition(id) {
    return api.post(`/api/library/acquisitions/${id}/cancel`);
  },
};

export default libraryService;
